//
//
//
//
//
//
//
//

import drawMixin from '../pages/screen/drawMixin'
export default {
    mixins: [drawMixin],
    data() {
        return {
            showRightWidow: true
        }
    },
    mounted() {},
    methods: {}
}
